<template>
  <div class="container">
    <div class="img">
      <img src="@/assets/images/pages/login/mobile_login_ikmv.svg">
    </div>
    <div class="login-container">
      <div class="form">
        <Logo class="logo text-primary fill-current" />
        <h3 class="trademark">Welcome to QuickSend</h3>
        <vs-divider></vs-divider>
        <div class="input-div mt-2">
          <div>
            <h5>Email</h5>
            <vs-input
              v-validate="'required|email|min:3'"
              size="large"
              type="email"
              name="email"
              icon-pack="feather"
              icon="icon-mail"
              icon-no-border
              v-model="email"
              label-placeholder="EMAIL"
              class="w-full mt-4"/>
              <span class="text-danger text-sm float-left">{{ errors.first('email') }}</span>
          </div>
        </div>
        <div class="input-div mb-8">
          <div>
            <h5>Password</h5>
            <vs-input
              v-validate="'required|min:6'"
              size="large"
              type="password"
              name="password"
              icon-pack="feather"
              icon="icon-lock"
              icon-no-border
              v-model="password"
              label-placeholder="PASSWORD"
              class="w-full mt-6"/>
              <span class="text-danger text-sm float-left">{{ errors.first('password') }}</span>
          </div>
        </div>
        <div class="flex flex-wrap justify-between mt-10">
          <router-link to="/signup">Signup</router-link>
          <router-link to="/forgot-password">Forgot Password</router-link>
        </div>
        <vs-button :disabled="!validateForm" @click="login" class="shadow-md w-full mt-2">LOGIN</vs-button>
        <vs-divider class=" mt-2 mb-2 text-l text-bold" color="black">OR GO EASY WITH</vs-divider>
        <div class="flex flex-wrap justify-between">
          <vs-button color="#3b5998" class="facebook">Facebook</vs-button>
          <vs-button color="#db3236" class="google">Google</vs-button>
        </div>  
      </div>  
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue';
import auth from '@/services/authService';
import router from '@/router';


export default {
  data() {
    return {
      email:'',
      password:'',
      checkbox_remember_me: false,
    }
  },
  components: {
    Logo,
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },

  created: function () {
    if (this.hasLogin()) this.$router.push('/dashboard');
  },

  methods: {
    hasLogin () {
      let loginStatus = auth.getLoginStatus();
      return loginStatus !== 0;
    },

    async login () {
      if (this.hasLogin()) this.$router.push('/dashboard');

      // Loading
      this.$vs.loading()

      auth.login(this.email, this.password, this.checkbox_remember_me)
        .then(async () => { 
          this.$vs.loading.close(); 
          let onboard_routes = [
            '/signup',
            '/signup/verify',
            '/signup/details',
            '/signup/orgdetails',
            '/signup/card',
            '/signup/package'
          ];

          let onboard_step = await auth.getOnboardStep();
          if (onboard_step >= onboard_routes.length) {
            let orgs = this.$store.state.user.organizations;
            if (_.isEmpty(orgs)) {
              router.push('/dashboard');
            } else {
              router.push('/login/organization');
            }
          } else {
            router.push(onboard_routes[onboard_step]);
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    registerUser (page) {
      if (this.hasLogin()) this.$router.push('/dashboard');
      this.$router.push({name: `${page}`}).catch(() => {})
    }
  }
}
</script>

<style scoped>
* {
    padding:0;
    margin: 0;
    box-sizing: border-box;   
}

body {
  display:grid;
  width:100%;
  height: 100%;
}

.container {
  margin: auto;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-template-areas: "image form";
    grid-gap: 10rem;
    padding: 0 2rem;
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-area: image;
}

.img img{
   width: 600px; 
}

.login-container {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
    grid-area: form;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.trademark{
    font-size: 1.5rem;
    text-transform: uppercase;
    margin: 15px 0;
    color: #F9278E;

    overflow: hidden; /* Ensures the content is not revealed until the animation */
    border-right: .15em solid #F9278E; /* The typwriter cursor */
    white-space: nowrap; /* Keeps the content on a single line */
    margin: 0 auto; /* Gives that scrolling effect as the typing happens */
    animation: 
    typing 3.5s steps(30, end),
    blink-caret .75s step-end infinite;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
}


@keyframes typing {
  from { width: 0 }
  to { width: 82% }
}

@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: #F9278E; }
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #F9278E;
}


.input-div > div {
    position: relative;
    height: 45px;

}

.input-div > div h5{
    position:absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #f9278e;
    display: none;
    font-size: 18px;
    transition: .3s;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 5rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    .img img{
        width: 400px;
    }
}

@media screen and (max-width: 900px) {
    .img{
        display:none;
    }
    .container{
        display: inherit;
    }
    .login-container{
        justify-content: center;
    }
}
</style>
